/* ============
 * normalize-text
 * ============
 *
 * https://www.npmjs.com/package/normalize-text
 */

import { normalizeText } from 'normalize-text';

export default normalizeText;
